"use client";

import { useState } from "react";
import { useTurnstile } from "@/lib/turnstile";
type FormStatus = "idle" | "submitting" | "success" | "error";

/**
 * Field state and a Turnstile-protected JSON POST for the site's simple
 * inquiry forms (contact, Full Service). `extraBody` adds fields read at
 * submit time, after the form fields and the Turnstile token.
 */
export function useTurnstileFormSubmission<T extends Record<string, string>>(endpoint: string, initialData: T, extraBody?: () => Record<string, unknown>) {
  const {
    token: turnstileToken,
    resetToken
  } = useTurnstile();
  const [formStatus, setFormStatus] = useState<FormStatus>("idle");
  const [formData, setFormData] = useState<T>(initialData);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = async (e_0: React.FormEvent) => {
    e_0.preventDefault();
    setFormStatus("submitting");
    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...formData,
          turnstile_token: turnstileToken,
          ...extraBody?.()
        })
      });
      if (!res.ok) throw new Error("Request failed");
      setFormStatus("success");
      resetToken();
    } catch {
      setFormStatus("error");
      resetToken();
    }
  };
  return {
    formData,
    formStatus,
    handleChange,
    handleSubmit
  };
}